angular.module('gym.mobile_app').controller('MobileAppSettingsCtrl', ["$scope", "$state", "$stateParams", "$location", "$rootScope", "$window", "EmploymentService", "MobileApp", function($scope, $state, $stateParams, $location, $rootScope, $window, EmploymentService, MobileApp) {
  var accessRequestsDisabled, bulkMobileAppChangesDisabled, getOpenTab;
  $scope.permissions = EmploymentService.get().permissions;
  if (!$scope.permissions.manage_mobile_app_details) {
    $state.go('gym.dashboard');
  }
  $scope.tab = $stateParams.tab || 'general';
  $scope.activatedTabs = {
    [`${$scope.tab}`]: true
  };
  bulkMobileAppChangesDisabled = function() {
    var ref;
    return !($scope.permissions.perform_bulk_mobile_app_operations && ((ref = $scope.mobileAppSettings) != null ? ref.review_status : void 0) === 'review_approved');
  };
  accessRequestsDisabled = function() {
    var ref;
    return !((ref = $scope.mobileAppSettings) != null ? ref.request_access_page_enabled : void 0);
  };
  $scope.tabs = [
    {
      name: 'general',
      title: 'General'
    },
    {
      name: 'features',
      title: 'Features'
    },
    {
      name: 'access_settings',
      title: 'Access Settings'
    },
    {
      name: 'design',
      title: 'Design Settings'
    },
    {
      name: 'proximity_checkin',
      title: 'Proximity Check-in',
      subtabs: [
        {
          name: 'event_locations',
          title: 'Event Locations',
          subtab: true
        },
        {
          name: 'proximity_checkin_addresses',
          title: 'Proximity Check-in Addresses',
          subtab: true
        },
        {
          name: 'event_defaults',
          title: 'Event Defaults',
          subtab: true
        }
      ]
    },
    {
      name: 'website_settings',
      title: 'Website Settings'
    },
    {
      name: 'access_requests',
      title: 'Access Requests',
      isDisabled: accessRequestsDisabled
    },
    {
      name: 'bulk_mobile_app_changes',
      title: 'Bulk Contact Changes',
      route: 'gym.reports.bulk_mobile_app_changes',
      isDisabled: bulkMobileAppChangesDisabled
    }
  ];
  $scope.getSettings = function() {
    return MobileApp.all('settings').getList().then(function(settings) {
      return $scope.mobileAppSettings = settings[0];
    });
  };
  $scope.onSettingsUpdated = function(settings) {
    return angular.extend($scope.mobileAppSettings, settings);
  };
  $scope.getSettings();
  $scope.isItemAvailable = function(item) {
    return !item.isDisabled || !item.isDisabled();
  };
  $scope.setTab = function(tab) {
    var confirmMessage;
    confirmMessage = $rootScope.stateChangeConfirmMessage;
    if (confirmMessage && !$window.confirm(confirmMessage)) {
      return;
    } else {
      $rootScope.stateChangeConfirmMessage = void 0;
      $window.onbeforeunload = void 0;
    }
    if (tab.route) {
      return $state.go(tab.route);
    } else {
      $location.search({
        'tab': tab.name
      });
      $scope.tab = tab.name;
      $scope.activatedTabs[tab.name] = true;
      if (tab.name === 'access_requests') {
        $scope.$emit('access_requests:reload');
      }
      if (!tab.subtab) {
        return $scope.openTab = tab.subtabs && $scope.openTab !== tab.name ? tab.name : void 0;
      }
    }
  };
  getOpenTab = function() {
    var open;
    open = _.find($scope.tabs, function(tab) {
      return $scope.tab === tab.name || _.find(tab.subtabs, function(subtab) {
        return $scope.tab === subtab.name;
      });
    });
    return $scope.openTab = open != null ? open.name : void 0;
  };
  getOpenTab();
  return $scope.isTabOpen = function(tab) {
    return $scope.openTab === tab.name;
  };
}]);
